// https://tkdodo.eu/blog/effective-react-query-keys#use-query-key-factories

const documentBlueprintKeys = {
  all: ['documentBlueprint'] as const,
  list: () => [...documentBlueprintKeys.all, 'list'] as const,
  detail: (id: string) => [...documentBlueprintKeys.all, 'detail', id] as const,
};

export default documentBlueprintKeys;
